module.exports = __webpack_public_path__ + "static/media/welcome1.882a05dd.png";